import PropTypes from 'prop-types';
import { Table } from 'antd';
import { formatRefDate } from '../../utils/formatRefDate';
import useNearestProvinces from './useNearestProvinces';

const columns = [
    { title: 'Report Time', dataIndex: 'reportDate', render: formatRefDate, width: 190 },
    { title: 'Vessel', key: 'vessel', render: (_, row) => row.ShipName || row.ShipCode || '—' },
    { title: 'Latitude', dataIndex: 'lat', render: value => value.toFixed(6) },
    { title: 'Longitude', dataIndex: 'lng', render: value => value.toFixed(6) },
];

export default function PositionReports({ reports, loading }) {
    const provinces = useNearestProvinces(reports);
    const displayColumns = [...columns.slice(0, 2), {
        title: 'Location', key: 'province', width: 200,
        render: (_, row) => provinces.loading ? 'Memuat...' : provinces.values[JSON.stringify([row.lat, row.lng])]?.name || '—',
    }, ...columns.slice(2)];
    return <>
        <Table size="small" columns={displayColumns} dataSource={reports} loading={loading}
            scroll={{ x: 850 }} pagination={{ pageSize: 10, showSizeChanger: false, showTotal: total => `${total} position reports` }}
            locale={{ emptyText: 'No position reports available' }} />
        {provinces.error && <p className="monitoring-note" role="status">Data provinsi tidak dapat dimuat. Muat ulang halaman untuk mencoba lagi.</p>}
        <p className="monitoring-note">Perkiraan provinsi Indonesia terdekat dari koordinat laporan terakhir, bukan batas wilayah laut atau posisi real-time.
            {' '}Batas provinsi: <a href="https://github.com/denyherianto/indonesia-geojson-topojson-maps-with-38-provinces" target="_blank" rel="noreferrer">Deny Herianto</a>
            {' '}(<a href="https://creativecommons.org/licenses/by/4.0/" target="_blank" rel="noreferrer">CC BY 4.0</a>).
        </p>
    </>;
}
PositionReports.propTypes = { reports: PropTypes.array.isRequired, loading: PropTypes.bool };
